import {ToolOutlined} from '@ant-design/icons'

import {
    useChoosePromptTemplate,
    useDefaultPromptTemplate,
    useLastPromptTemplate,
    usePromptTemplates,
} from '@/biz/promptTemplate.jsx'

import {DraftButton, DraftIconButton, useAiContext} from './core'

const useAutoLoad = (extra) => {
    const ai = useAiContext()
    const {project, scene} = ai
    const {data: templates} = usePromptTemplates(scene, project.pkid, extra)
    const {data: defaultId} = useDefaultPromptTemplate(scene, project.pkid)
    const {data: lastId} = useLastPromptTemplate(scene)

    if (
        ! ai.template &&
        templates &&
        void 0 !== lastId &&
        (void 0 !== defaultId || ! project.pkid)
    ) {
        if (defaultId) {
            const defaultTmpl = templates.find(
                e => e.llmId + e.pkid === defaultId
            )

            if (defaultTmpl) {
                ai.setTemplate(defaultTmpl)
                return
            }
        }

        const lastTmpl = templates.find(
            e => e.llmId + e.pkid === lastId
        )

        if (lastTmpl) {
            ai.setTemplate(lastTmpl)
        }
        else if (0 < templates.length) {
            ai.setTemplate(templates[0])
        }
    }
}

export const ButtonChooseTemplate = ({extra, ...props}) => {
    const ai = useAiContext()
    useAutoLoad(extra)
    const chooseTemplate = useChoosePromptTemplate()
    const {project, scene} = ai

    const onClick = async () => {
        const template = await chooseTemplate(scene, project.pkid, extra)

        if (template) {
            ai.setTemplate(template)
        }
    }

    if (ai.compactView) {
        const title = `选择AI助手\n当前助手：${ai.template?.llmName ?? '无'}`

        return (
            <DraftIconButton
                disabled={! project}
                title={title}
                onClick={onClick}
                {...props}
            >
                <ToolOutlined />
            </DraftIconButton>
        )
    }
    else {
        const title = `当前助手：${ai.template?.llmName ?? '无'}`

        return (
            <DraftButton
                disabled={! project}
                title={title}
                onClick={onClick}
                {...props}
            >
                选择AI助手
            </DraftButton>
        )
    }
}
